<template>
  <vs-button
    :color="activeLink ? 'primary' : 'dark'"
    :type="activeLink ? 'filled' : 'border'"
    icon-pack="feather"
    :icon="icon"
    :size="size"
    @click="navigate">
    {{ title }}
  </vs-button>
</template>

<script>
export default {
  name: 'NestedMenuTabButton',
  props: {
    route: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  computed: {
    currentRoute () {
      return this.$store.getters.currentRoute
    },
    activeLink () {
      return this.currentRoute.name && this.currentRoute.name.includes(this.route)
    }
  },
  methods: {
    navigate () {
      this.$router.push({ name: this.route })
    }
  }
}
</script>

<style scoped>

</style>
